import { render } from "./complianceSummaryPill.vue?vue&type=template&id=5b96cd14&scoped=true"
import script from "./complianceSummaryPill.vue?vue&type=script&lang=js"
export * from "./complianceSummaryPill.vue?vue&type=script&lang=js"

import "./complianceSummaryPill.vue?vue&type=style&index=0&id=5b96cd14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b96cd14"]])

export default __exports__